import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import config from '../../config/config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import payment from "../../assets/images/scannerfile.jpg"
import RenderRazorpay from '../../common/RenderRazorPay'
import ReCAPTCHAComponent from '../../common/googleCaptcha';
import { useDispatch, useSelector } from 'react-redux';
import { clearCart, selectCartData, selecteDiscount, selectTotalBookPrice, totalPrice, witoutDiscoutTotalPrice } from '../../ReduxSlice/BookSlice';
import { createRazorpayPaymentLink } from '../../common/RazorPayPartialPayment';
import generateEmailBody from '../../common/EmailBody';
import sendEmail from '../../common/SendEmail';

const emailHedingCahsh = "Cash Payment Recieved";
const emailHedingOnine = "Invoice Order Book";
const emailHeadingPymentLink="Invoice Order Book"


const Form = ({ paymentMode }) => {
  console.log("paymentMode",paymentMode)
  const { API_BASE_URL, RAZOR_PAY_API_KEY, RAZOR_PAY_API_SECRET } = config;
  const cartItems = useSelector(selectCartData)
  const actualPrice = cartItems.reduce((total, item) => total + item.withoutDiscountPrice * item.quantity, 0)
  const total = useSelector(witoutDiscoutTotalPrice)
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [error, setErrors] = useState({mobile :''});
   const discount = useSelector(selecteDiscount);
  //  console.log("@@discout",discount);
  //  console.log("actualPrice@123",actualPrice)



  const location = useLocation();

  //const cartItems = location.state ? location.state.cartItems : [];
  // const total = cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
  console.log("checktotal", total, cartItems)
  const deliveryCharge = location.state ? location.state.delivery : 0;

  const [displayRazorpay, setDisplayRazorpay] = useState(false);

  const [ordeid, setorderID] = useState("");
  const [preFillFormData, setPreFillFormData] = useState({
    name: '',
    mobile: '',
    email: ''
  });
  const [hemOrderID, setHemOrderId] = useState(null);



  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    pinCode: '',
    address: '',
    city: '',
    state: '',
  });
  // const [form ,setform]=useState(formData)
  // const formDatas = formData;
  // console.log("formdata in array",formDatas);

  const [paymentProofImage, setPaymentProofImage] = useState(null);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false); // Captcha state
  const [loading, setLoading] = useState(false);
    const paymentId= `cashpay_${new Date().toISOString().split('T')[0].replace(/-/g, '')}_${Math.floor(Math.random()*10000)}`;


  const handleRecaptcha = (value) => {
    setIsCaptchaValid(!!value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPreFillFormData({
      name: formData.name ,
      mobile: formData.mobile,
      email: formData.email
    });
    setLoading(true);
    setIsCaptchaValid(false);

    //  const storedCart = localStorage.getItem('cart');
    // const cartItems = storedCart ? JSON.parse(storedCart) : [];

     const checkoutPayload = {
      total: Number(total.toFixed(2)),
      deliveryCharges: deliveryCharge,
      orderDate: new Date().toISOString(),
      paymentDate: new Date().toISOString(),
      paymentProof: paymentProofImage,
      ...formData,
      _lstUM_OrderItem: cartItems
        .filter(item => item.quantity > 0)
        .map(item => ({
          bookId: item.id,
          bookName: item.name,
          bookQuantity: item.quantity,
          perUnitBookPrice: item.withoutDiscountPrice,
          totalBookPrice: item.withoutDiscountPrice * item.quantity,
          addDate: new Date().toISOString(),
          updateDate: new Date().toISOString(),
        })),
      _lstUM_OrderStatus: [
        {
          id: 0,
          orderId: 0,
          statusID: 0,
          statusName: 'string',
          updateDate: new Date().toISOString(),
          updatedBy: 0,
          isActive: 0,
        },
      ],
    };

    try {
      const response = await fetch(`${API_BASE_URL}/Home/Checkoutorder`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(checkoutPayload),
      });

      if (response.ok) {
        const data = await response.text();
        const RazorpayorderIds = JSON.parse(data).gatewayOrderID
        console.log("data", JSON.parse(data).gatewayOrderID);
        const hemOrderId = JSON.parse(data).orderId;
        setHemOrderId(hemOrderId)
        setDisplayRazorpay(true);
        setorderID(RazorpayorderIds);
        setLoading(false);
        setIsCaptchaValid(false);


        if (paymentMode === 'cashPay') {

          // console.log("@@@!!!##",paymentMode)
          const newOrderDetails = {
            orderId: RazorpayorderIds,
            // paymentId: `cashpay_${new Date().toISOString().split('T')[0].replace(/-/g, '')}_${Math.floor(Math.ranndom()*10000)}`,
            paymentId: paymentId,
            signature: "7a68edb84c919dd6c0bb48be543903f71f30e2864c4ccd73fc0d28113a54aa04",
            Status: "succeeded",
            Currency: "INR",
            Amount: total,
            PaymentMode: "cashPay"
          };
         


          try {
            const res = await fetch(`${API_BASE_URL}/api/Order/Capture-Payment`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(newOrderDetails,)
            });
            if (res.ok) {
              // console.log("check",emailHedingCahsh,JSON.parse(data).orderId, total, formData, PartialRazorPayLink,checkoutPayload,discount,actualPrice);
              const emailBodyHTML =  generateEmailBody(emailHedingCahsh,JSON.parse(data).orderId, total, formData, PartialRazorPayLink,checkoutPayload,discount,actualPrice);
       
              // await sendEmail('sales@mail.edumitram.co.in', 'New Order Notification by CashPay', emailBodyHTML);
              await sendEmail(formData.email, ' Your payment received by cash', emailBodyHTML);

              sessionStorage.setItem('paymentId',newOrderDetails.paymentId)
               navigate('/transactionslip')

            }

            else if (!res.ok) {
              throw new Error('Failed to save payment response');
            }

            // alert(`Payment ${status}`);

          } catch (error) {
            console.error('Error:', error);
          }
        }
        else if(paymentMode === "paybyMail"){
          console.log("paybyMail")

           var PartialRazorPayLink= await createRazorpayPaymentLink(ordeid, total,formData, API_BASE_URL);
          // var PartialRazorPayLink ="saurabhmailpayment"
          const emailBodyHTML =  generateEmailBody(emailHeadingPymentLink,JSON.parse(data).orderId, total, formData, PartialRazorPayLink,checkoutPayload,discount,actualPrice);
       
          await sendEmail(formData.email, 'Thanks New Order Book', emailBodyHTML);
          
        }
        else if(paymentMode === "online"){
          console.log("online")

          const emailBodyHTML =  generateEmailBody(emailHedingOnine,JSON.parse(data).orderId, total, formData, PartialRazorPayLink,checkoutPayload,discount,actualPrice);
       
          await sendEmail(formData.email, ' Thanks New Order Book', emailBodyHTML);
        }

        dispatch(clearCart());
        dispatch(totalPrice(0));
       


        toast.success(
          <div className='z-99 mt-5'>
            <p>Please save the order for tracking and future reference.</p>
            <hr />
            <p className='font-bold'> Order Id : &nbsp; {hemOrderId}</p>
            <button className='mt-1 bg-red-500 rounded-md text-white text-xs px-2 py-1.5' onClick={() => toast.dismiss()}>Close</button>
          </div>,
          { autoClose: false }
        );
       

        localStorage.removeItem('cart');

        setFormData({
          name: '',
          mobile: '',
          email: '',
          pinCode: '',
          address: '',
          city: '',
          state: '',
        });

        setPaymentProofImage(null);
       
        setLoading(false);

      } else {
        toast.error('Error while saving the order. Please try again.');
        setLoading(false);
        setIsCaptchaValid(false)
      }
    } catch (error) {
      toast.error('An unexpected error occurred. Please try again later.');
      setLoading(false);
      setIsCaptchaValid(false)
    }
  };

  const handleChange = (e) => {
    const {name ,value} = e.target;
    console.log("name",name,value);
      // Restrict mobile input to 10 digits
      // if (name === "mobile" && value.length > 10) {
      //   return; // Do nothing if the input exceeds 10 digits
      // }
    setFormData({...formData,[name]:value});


    const phoneRegex = /^[6-9]\d{9}$/;
    if(name === "mobile"){
      console.log("phoneRegex.test(value)",phoneRegex.test(value))
      
        if(value === "" || phoneRegex.test(value)){
          setErrors((prevErrors)=>({
            ...prevErrors,mobile:""
          }));
        }else{
          setErrors((prevErrors)=>({
            ...prevErrors,mobile:"Invalid phone number"
          }))
        }
      
    }else{
      setFormData({ ...formData, [name]: value});


    }
  };

  const handleImageChange = (e) => {

    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPaymentProofImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (

    <section className=" h-[55vh] md:h-auto overflow-y-auto relative max-w-7xl mx-auto px-5">
      <div className="container z-10">
        <div className="flex flex-wrap -mx-4">
          <div className="w-full px-4">
            <div className="  relative rounded-lg shadow-lg">
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="text-gray-700 font-medium">
                      Name
                      <input
                        type="text"
                        placeholder="Mention your name"
                        className="w-full rounded py-1.5 px-[14px] placeholder:text-sm text-body-color text-base border border-gray-300 outline-none focus:border-primary"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        
                      />
                    </label>
                  </div>

                  <div>
                    <label className="text-gray-700 font-medium">
                      Mobile
                      <input
                        placeholder="+91 75*******"
                        className="w-full rounded py-1.5 px-[14px] placeholder:text-sm text-body-color text-base border border-gray-300 outline-none focus:border-primary"
                        type="text"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        maxLength={10}
                        
                      />
                      {error.mobile && <p className='text-red-500'>{error.mobile}</p>}
                    </label>
                  </div>

                  <div>
                    <label className="text-gray-700 font-medium">
                      Email <span className='text-red-600'>*</span>
                      <input
                        placeholder="name@gmail.com"
                        className="w-full rounded py-1.5 px-[14px] placeholder:text-sm text-body-color text-base border border-gray-300 outline-none focus:border-primary"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </label>
                  </div>

                  <div>
                    <label className="text-gray-700 font-medium">
                      Pincode
                      <input
                        placeholder="Mention your Pincode"
                        className="w-full rounded py-1.5 px-[14px] placeholder:text-sm text-body-color text-base border border-gray-300 outline-none focus:border-primary"
                        type="text"
                        name="pinCode"
                        value={formData.pinCode}
                        onChange={handleChange}
                       
                      />
                    </label>
                  </div>

                  <div className="md:col-span-2">
                    <label className="text-gray-700 font-medium">
                      Address
                      <input
                        placeholder="Write your address with Street name"
                        className="w-full rounded py-1.5 px-[14px] placeholder:text-sm text-body-color text-base border border-gray-300 outline-none focus:border-primary"
                        type="text"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        
                      />
                    </label>
                  </div>

                  <div>
                    <label className="text-gray-700 font-medium">
                      City
                      <input
                        placeholder="Mention your City"
                        className="w-full rounded py-1.5 px-[14px] placeholder:text-sm text-body-color text-base border border-gray-300 outline-none focus:border-primary"
                        type="text"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        
                      />
                    </label>
                  </div>

                  <div>
                    <label className="text-gray-700 font-medium">
                      State
                      <input
                        placeholder="Mention your State"
                        className="w-full rounded py-1.5 px-[14px] placeholder:text-sm text-body-color text-base border border-gray-300 outline-none focus:border-primary"
                        type="text"
                        name="state"
                        value={formData.state}
                        onChange={handleChange}
                        
                      />
                    </label>
                  </div>
                </div>

                {cartItems.map((item, index) => (
                  <React.Fragment key={index}>
                    <input type="hidden" name={`cartItems[${index}].bookId`} value={item.bookId} />
                    <input type="hidden" name={`cartItems[${index}].bookName`} value={item.bookName} />
                    <input type="hidden" name={`cartItems[${index}].bookQuantity`} value={item.bookQuantity} />
                    <input type="hidden" name={`cartItems[${index}].perUnitBookPrice`} value={item.perUnitBookPrice} />
                    <input type="hidden" name={`cartItems[${index}].totalBookPrice`} value={item.totalBookPrice} />
                    <input type="hidden" name={`cartItems[${index}].addDate`} value={item.addDate} />
                    <input type="hidden" name={`cartItems[${index}].updateDate`} value={item.updateDate} />
                  </React.Fragment>
                ))}

                <div className="mt-2">
                  <ReCAPTCHAComponent onChange={handleRecaptcha} />
                </div>

                <div className="mt-2">
                  <button
                    type="submit"
                    disabled={!isCaptchaValid}
                    className={`w-full bg-blue-600 rounded border border-primary p-3 transition ${!isCaptchaValid ? "cursor-not-allowed opacity-50" : ""
                      } hover:bg-blue-700 text-white`}
                  >
                    {!loading ? "Place Order" : "Placing Order..."}
                  </button>
                </div>

                {displayRazorpay && paymentMode === 'online' && (
                  <RenderRazorpay
                    amount={total}
                    currency="INR"
                    orderId={ordeid}
                    keyId={RAZOR_PAY_API_KEY}
                    keySecret={RAZOR_PAY_API_SECRET}
                    preFillFormData={preFillFormData}
                    hemOrderID = {hemOrderID}
                  />
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>

  );
};

export default Form;
